export default "__VITE_ASSET__DYdyUCKW__"